<!-- @format -->
<ng-container *transloco="let t">
  <fudis-dialog data-cy="select-substitution-modal" [size]="'md'">
    <fudis-heading [level]="2" fudisDialogTitle>{{ t("SUBSTITUTIONS.SELECTOR.TITLE") }}</fudis-heading>
    <fudis-dialog-content [contentFocus]="true">
      <fudis-body-text>{{ t("PLAN.SUBSTITUTION.INTRO_1") }}</fudis-body-text>
      <fudis-body-text class="fudis-mb-md" [variant]="'md-light'">{{ t("PLAN.SUBSTITUTION.INTRO_2") }}</fudis-body-text>

      @if (candidates$ | async; as rows) {
        @if (rows.length > 1) {
          <fudis-heading [level]="3" class="fudis-mb-xs">{{ t("PLAN.SUBSTITUTION.SELECT_LABEL") }}</fudis-heading>
          <fudis-body-text class="fudis-mb-sm" [variant]="'md-light'">
            {{
              t("PLAN.SUBSTITUTION.SELECT_GUIDANCE", {
                code: data.courseUnit.code,
                name: (data.courseUnit.name | localizedString),
              })
            }}
          </fudis-body-text>

          @for (row of rows; track row.localId) {
            <div
              class="substitution-option-row fudis-p-sm fudis-mb-sm"
              [class.selected]="control.value === row.localId"
              [attr.data-cy]="row.optionNumber === null ? 'substitution-option-none' : 'substitution-option-' + row.optionNumber">
              <sis-radio-button
                [translatedLabel]="
                  row.optionNumber === null
                    ? t('PLAN.SUBSTITUTION.NO_SELECTION')
                    : t('PLAN.SUBSTITUTION.OPTION', { index: row.optionNumber })
                "
                [control]="control"
                [value]="row.localId"
                [id]="row.localId === null ? 'substitution-option-none' : 'substitution-option-' + row.localId"
                name="substitution-option"
                [ariaDescribedBy]="row.localId === null ? undefined : optionAriaDescribedBy(row)">
              </sis-radio-button>

              @for (courseUnit of row.courseUnits; track courseUnit.id; let i = $index) {
                <div [id]="courseUnitDescriptionId(row, i)">
                  <fudis-body-text class="fudis-ml-lg" [variant]="'lg-regular'">
                    {{ courseUnit.code }}, {{ courseUnit.name | localizedString }} ({{ courseUnit.credits | creditRange }})
                  </fudis-body-text>
                  @if (courseUnit.usedCredits) {
                    <fudis-body-text class="fudis-ml-lg fudis-mt-xs" [variant]="'md-light'">
                      {{ t("SUBSTITUTIONS.CREDITS", { credits: courseUnit.usedCredits }) }}
                    </fudis-body-text>
                  }
                </div>
                <a
                  fudisLink
                  [external]="true"
                  [title]="t('PLAN.SUBSTITUTION.SHOW_DETAILS')"
                  [href]="courseUnitInfoUrl(courseUnit.id)"
                  class="fudis-mt-xs fudis-mb-md fudis-ml-lg"></a>
              }
            </div>
          }
        } @else {
          <fudis-body-text class="no-results">{{ t("SUBSTITUTIONS.SELECTOR.TITLE_NONE") }}</fudis-body-text>
        }
      } @else {
        <fudis-loading-spinner [label]="t('PLAN.SUBSTITUTION.LOADING')" />
      }
    </fudis-dialog-content>
    <fudis-dialog-actions>
      <fudis-button variant="secondary" fudisDialogClose [label]="t('SIS_COMPONENTS.BUTTON.CANCEL')" />
      <fudis-button data-cy="select-substitution-modal-save-button" [label]="t('PLAN.SUBSTITUTION.SAVE')" (handleClick)="save()" />
    </fudis-dialog-actions>
  </fudis-dialog>
</ng-container>
